export default __webpack_public_path__ + "static/media/CDP_Digital_BROCHURE_1.a0b11973.pdf";